import React, { useState, useEffect } from "react";
import RejectedModule from "../RejectedManuscript/RejectedModule";
import AcceptingModule from "../AcceptedManuscript/AcceptingModule";
import RejectedManuscript from "../RejectedManuscript/RejectedManuscript";
import { approveText, unresolveText } from "../ActionText/ActionText";
import AxiosService from "../../utils/AxiosService";
import { toast } from "react-toastify";

const Modal = ({ modal, setModal,handleConfirm}) => {
  const apiService = new AxiosService();
  const [show, setShow] = useState(false);
  const [comment, setComment] = useState("");

  const handleClose = () => {
    setShow(false);
    setModal({
      show: false,
      modalType: "",
      header: "",
      message: "",
    });
  };

  const handleSubmit = () => {
    handleConfirm(comment)
    setShow(false);
    setModal({
      show: false,
      modalType: "",
      header: "",
      message: "",
    });
  };
  

  const handleShow = () => setShow(true);

  useEffect(() => {
    if (modal.show) {
      handleShow();
    }
    // else{
    //   console.log("elseee");
    //   setShow(false);
    // }
  }, [modal]);

  return (
    <div>
      {show && (
        <div
          className="modal fade show"
          tabIndex="-1"
          style={{ display: "block", backgroundColor: "rgba(0, 0, 0, 0.5)" }}
        >
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              {/* Modal Header */}
              <div className="modal-header align-items-start">
                <div className="modal-title">
                  <h5>{modal.header}</h5>
                  <p>{modal.message}</p>
                </div>
                <button
                  type="button"
                  className="btn-close"
                  onClick={handleClose}
                ></button>
              </div>

              {/* Modal Body */}
              <div className="modal-body">
                <div>
                  <div className="mt-1">
                    <h6 className="text-muted ms-3">
                      <strong>{modal.actionName}:</strong>{" "}
                      {/* <span className="text-muted unresolveText">
                        <i
                          className="d-inline-block bi bi-arrow-clockwise"
                          style={{ strokeWidth: "5px", stroke: "white" }}
                        ></i>
                        <span className=" "> {modal.action}</span>
                      </span> */}
                       {modal.action.replace("Revert","") === "Unresolve"
                        ? unresolveText
                        : approveText}
                    </h6>
                    {/* <div className="d-flex">
                      <div className="col">
                        <RejectedModule />
                      </div>
                      <div className="col">
                        <AcceptingModule />
                      </div>
                    </div> */}
                    {ModalType(modal.modalType, modal,comment,setComment)}
                  </div>
                </div>
              </div>

              {/* Modal Footer */}
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={handleClose}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={() => {
                    handleSubmit();
                    console.log("Confirm action");
                  }}
                >
                  Confirm
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );

};
function ModalType(modalType, modal,comment,setComment) {
  switch (modalType) {
    case "unresolved":
      return (
        <div className="d-flex">
          <div className="col">
            <RejectedModule modal={modal} clientData={modal.clientData} curationData={modal.curationData} comment={comment} setComment={setComment}/>
          </div>
        </div>
      );
    case "approved":
      return (
        <div className="d-flex">
          <div className="col">
            <RejectedModule modal={modal} clientData={modal.clientData} curationData={modal.curationData} comment={comment} setComment={setComment}/>
          </div>
          <div className="col">
            <AcceptingModule modal={modal} curationData={modal.curationData}/>
          </div>
        </div>
      );
      
    case "keepPreviousAction":
      break;
    case "changeAction":
      break;

    default:
      return "";
  }
}

export default Modal;
